$(function() {
 
  // klarna
  
  $('.klarna_btn').on('click', function(){
    $('.klaran_popup').show();
  });
  
  $('.klpp_close, .klpp_bg, .klpp_close_btn').on('click', function(){
    $('.klaran_popup').hide();
  });
  
  $('.pdthub_img').on('click', function() {
     var img = $(this).data('img');
     var price = $(this).data('price');
     var compare = $(this).data('compare');
     var href =  $(this).data('url');
       
    $('.pdthub_img').removeClass('active');
    $(this).addClass('active');

     $(this).closest('.product-card').find('.price-item--sale').html(price);
     $(this).closest('.product-card').find('.price-item--regular').html(compare);
     $(this).closest('.product-card').find('.product_img img').attr('src', img);
     $(this).closest('.product-card').find('a').attr('href', href);
  });
  
  
  
  
  
  var current_url = $(location).attr('pathname');  
  var last = current_url.substr(current_url.length - 1);
  
  if(last == '/'){
    current_url = current_url.substring(0,current_url.length - 1);
   // window.location.href = current_url;
  }
 
  
  // scroll
  var c_url = $(location).attr('href');  
  if(c_url.indexOf('warranty') != -1){
      $("html, body").animate({ scrollTop: 0 }, 400);
    }
  
  
   $("body").on("click",".questions",function() {
     	$(this).find('span.on').toggleClass('custom_hide');
     	$(this).find('span.off').toggleClass('custom_hide');
     	$(this).next('.answers').slideToggle();
     	
    });
  
  
  /*
  $('.product_img_slider').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        adaptiveHeight: true
  });
   */
  
  /*
    $('.mobile_slider_item').slick({
      	dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          adaptiveHeight: true
      });
      */
  
  $('.blog_slider').slick({
    	dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              dots: true,
              infinite: false,
              speed: 300,
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
  });
	
  if($('.custom_slider').length > 0) {
    $('.custom_slider').slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {             
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  
  if($(".collectionVideos").length > 0) {
    $(".collectionVideos .videoList").slick({
      infinite: true,
      dots: false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 2,
      responsive: [

        {
          breakpoint: 1024,
          settings: {
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
      
    });
  }
  
  
  $('[data-slider-container_1] .quotes-slider').slick({
      infinite: true,
      dots: true,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 2,
      responsive: [

        {
          breakpoint: 1024,
          settings: {
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
      
    });
  


$("body").on("click", ".infoDropdown .infoHeader", function(){
  $(this).next(".dropInfo").stop().slideToggle();
  $(this).parent("li").stop().toggleClass("active");
});
$("body").on("click", ".productTabs .tabHeader li", function(){
  let ind = $(this).index();
  $(".productTabs .tabHeader li").removeClass("active");
  $(this).addClass("active");
  $(".productTabs .tabContent").removeClass("active");
  $(".productTabs .tabContentContainer .tabContent:eq("+ind+")").addClass("active");
});

$("body").on("click", ".mediaArrows .arrowPrev", function(event){
	 
  if($(".product-single__media-wrapper.js").not(".product-single__media-wrapper.js.hide").prev(".product-single__media-wrapper.js").length > 0) {
    let cur = $(".product-single__media-wrapper.js").not(".product-single__media-wrapper.js.hide");
    $(".product-single__media-wrapper.js").not(".product-single__media-wrapper.js.hide").prev(".product-single__media-wrapper.js").removeClass("hide");
    cur.addClass("hide");
    let index = cur.data('index');
    console.log(index);
    
    index = parseInt(index) - 1;
  
    $('[data-slider-track] li a').removeClass('active-thumb'); 
    $('[data-slider-track] li:eq('+index+') a').addClass('active-thumb');
  }
  
});

$("body").on("click", ".mediaArrows .arrowNext", function(event){  
   
  let index = 0;
  if($(".product-single__media-wrapper.js").not(".product-single__media-wrapper.js.hide").next(".product-single__media-wrapper.js").length > 0) {
    let cur = $(".product-single__media-wrapper.js").not(".product-single__media-wrapper.js.hide");
    $(".product-single__media-wrapper.js").not(".product-single__media-wrapper.js.hide").next(".product-single__media-wrapper.js").removeClass("hide");
    cur.addClass("hide");
    index = cur.data('index');    
  }
  else {
    $(".product-single__media-wrapper.js.seq_1").removeClass("hide");
    cur.addClass("hide");
    index = cur.data('index'); 
  }
  index = parseInt(index) + 1;
  
  $('[data-slider-track] li a').removeClass('active-thumb'); 
  $('[data-slider-track] li:eq('+index+') a').addClass('active-thumb');
  
});


  
  $('.qty_sign').on('click', function(){
    var qty = parseInt($(this).closest('.qty_flx').find('.cart__qty-input').val());
    if($(this).hasClass('qty_plus')){
      qty +=1; 
    }else{
      qty -=1;
    }
    
    if(qty !=0){
      $(this).closest('.qty_flx').find('.cart__qty-input').val(qty);
    }
    
    
  });
  
  
  
  
  
  
});


$(window).on("scroll", function(){
  if($(this).scrollTop() > 140) {
    $(".site-header").addClass("fixedHeader");
    $("body").addClass("headerFixed");	
  }
  else {
    $(".site-header").removeClass("fixedHeader");
    $("body").removeClass("headerFixed");	
  }
});





$(function(){
  
   var select_length = $('.variantSelector .selector-wrapper').length;

  
   setTimeout(function() {
       mobile_option();
    }, 200);
   
      var slider_mobile = $('.mobile_slider_item');
      slider_mobile.slick({
      	dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          adaptiveHeight: true
     });

  
  
      $('.color_options .itme_color').on('click, mouseenter', function(){ 
        
          var value = $(this).attr('value');
          var id = $(this).attr('data-id');
          var img = $(this).attr('data-img');
        
          $('.color_options .itme_color').removeClass('selected');
          $(this).addClass('selected');
          $('.single-option-selector').val(value).change();
          var html = $('.single-option-selector option:selected').html();
           
          var info = '';
          if(typeof html !== 'undefined')
          info = html.replace(value, ""); 
        
          $('.select_pre_order').html(value);
          $('.addon_info').html(info);
      
          $('[name="id"]').val(id).trigger('change');
      
         $('.product-single__media-wrapper').addClass('hide');
         $('.product-single__media-wrapper[href="'+img+'"]').removeClass('hide');

         select_preorder_2();
          mobile_option();
             
      });
  
     $('.color_options .two_col_item').on('click, mouseenter', function(){ 
           var val1 =$(this).attr('data-n');
           var val2 =$(this).attr('data-m');
         
          setTimeout(function() {
             SingleOption(val1, val2);
          },100);
         
     });

    function SingleOption(val1, val2) {
        console.log(val1);  console.log(val2);
       $('#SingleOptionSelector-0').val(val1);
       $('#SingleOptionSelector-1').val(val2);
      
      let element = document.getElementById("SingleOptionSelector-0");
      let changeEvent = new Event('change');
      element.dispatchEvent(changeEvent)

     
      
       
    }
  
    function mobile_option() {
        var img_id = $('[name="id"] option:selected').attr('data-img');
        var img_count = $('.slider_item[data-id="'+img_id+'"]').attr('data-no'); 
      
         if(typeof img_count !== 'undefined')
         slider_mobile.slick('slickGoTo', img_count);
    }
  
  
  $('.single-option-selector').on('change', function(){
    var select = $(this).val();
    //select_preorder(select);    
    
    select_preorder_2();
  });
  
  if(typeof pre_order !== 'undefined'){
    var value = $('.single-option-selector').val();
    //select_preorder(value);
  }
  
  select_preorder_2(); 

  function select_preorder(value){
     
    setTimeout(function(){
      
      
      if(jQuery.inArray(value, pre_soldout) !== -1){
         $('.txt_pre_order, .txt_in_stock').hide();
         $('.txt_soldOut').show();
      
      } else if(jQuery.inArray(value, pre_order) !== -1){
        
        $('.pre_order_txt').attr('name', 'properties[Order Type]');
        $('.pre_order_info').attr('name', 'properties[Shipping Information]');
        $('#AddToCart span').html('Back Order');
        
        if(typeof pre_orer_info !== 'undefined'){
        $(pre_orer_info).each(function(index, item){
          
          if(item.variant == value){
            $('.pre_order_info').val(item.info);
          }
          
        });
      }
        
        $('.txt_pre_order').show();
        $('.txt_in_stock, .txt_soldOut').hide();

      }else{

        $('.pre_order_txt, .pre_order_info').removeAttr('name');         
        $('.txt_pre_order, .txt_soldOut').hide();
        $('.txt_in_stock').show();
      }
    }, 50);
    
  }
  
   function select_preorder_2(){

     console.log('gaurav');
     
    setTimeout(function(){
     var select_id = $('[name="id"]').val();
       
       if(typeof pre_orer_info !== 'undefined'){
          $(pre_orer_info).each(function(index, item){
        
        if(select_id == item.var_id){
           
          
          if(!item['var_available']){
            if (window.useBadges == 'false') {
              $('.txt_pre_order, .txt_in_stock').hide();
              $('.txt_soldOut').show();
            }
            
          }else{
            
            $('.pre_order_txt').attr('name', 'properties[Order Type]');
            $('.pre_order_info').attr('name', 'properties[Shipping Information]');
            
            
            if(item.var_qty <= 0){
              $('.pre_order_info').val(item.info);
              if (window.useBadges == 'false') {
                $('.txt_pre_order').show();
                $('.txt_in_stock, .txt_soldOut').hide();
              }
              $('#AddToCart span').html('Back Order');

            }else{
              $('.pre_order_txt, .pre_order_info').removeAttr('name');   
              if (window.useBadges == 'false') {      
                $('.txt_pre_order, .txt_soldOut').hide();
                $('.txt_in_stock').show();
              }
              
              $('#AddToCart span').html('Add to Cart');

            }
          }
        }
        
      });
       }
      if(select_length == 2){
     	insert_txt();
      }
      
    }, 50);
    
  }
  
  
  function insert_txt(){
     
    var select_2 = $('.variantSelector .selector-wrapper:nth-child(2) select.single-option-selector').val();
    
     $('.variantSelector .selector-wrapper:nth-child(1) select.single-option-selector option').each(function(){
        var that = $(this);
        var txt = that.attr('value');
       
       var option = txt +' / '+ select_2;
        
       
      $('.add_txt_dropvalue li').each(function(){
              var title = $(this).data('title');        
              var available = $(this).data('available');
              var preorder = $.trim($(this).data('preorder'));
              var dropdown = $.trim($(this).data('infodrop')); 
         
            if(dropdown == ''){
              dropdown = 'Back Order - Ships Within 2-4 Weeks';
            }else{
              dropdown = ''+dropdown+'';
            }

            if(option == title && available == '0'){
               that.html(txt+' Soldout');
            }else if(option == title && preorder == '1'){
               that.html(txt+ ' '+dropdown);
            }else if(option == title && available == '1'){
              if(dropdown ==''){
              	that.html(txt+' In stock: Delivery within 7-14 business days');
              }else{
                that.html(txt+ ' '+dropdown);
              }
            }

          });
     });
    
    
  }
  
  
  if(select_length == 2){
     insert_txt();
  }else{
  
      $('select.single-option-selector option').each(function(){
        var that = $(this);
        var option = that.val();
        $('.add_txt_dropvalue li').each(function(){
            var title = $(this).data('title');
            var available = $(this).data('available');
            var preorder = $.trim($(this).data('preorder'));
            var dropdown = $.trim($(this).data('infodrop'));  

          if(dropdown == ''){
            dropdown = 'Back Order - Ships Within 2-4 Weeks';
          }else{
            dropdown = ''+dropdown+'';
          }

          if(option == title && available == '0'){
             that.html(title+' Soldout');
          }else if(option == title && preorder == '1'){
             that.html(title+ ' '+dropdown);
          }else if(option == title && available == '1'){
            that.html(title+' In stock: Delivery within 7-14 business days');
          }

        });
      });
  
  }
 
});

function _preSelectOption() {
    if ($('.color_options').length > 0) {
        let currentColor = $('.itme_color.selected'),
            dropdownOption = $('.single-option-selector option[value="' + currentColor.attr('value') + '"]').text(),
            text = dropdownOption.replace(currentColor.text().trim(), '');
        $('.addon_info').html(text).removeClass('hidden');
    }
}

setTimeout(function () {_preSelectOption()}, 500)

var bkc = {
  check_pincode: function(){
  	
  	$('.pincode_btn').on('click', function(){
  		var value = $(this).closest('.pincode_flx').find('.pincode_value').val();
  	 
      if($.inArray(value, pincode) !== -1){
        $('form #AddToCart, form [name="checkout"]').removeClass('disable_btn');
        $('.check_msg').html('Available at '+value).removeClass('error');
        
      }else{
         $('form #AddToCart, form [name="checkout"]').addClass('disable_btn'); 
         $('.check_msg').html('Zip code is out of delivery range. Please call Customer Service to complete your purchase').addClass('error');
          $('body').append('<div class="zip_msg">Zip code is out of delivery range. Please call Customer Service to complete your purchase</div>');
         hide_popup() ;
      }
        
	});
    
    function hide_popup(){
      setTimeout(function(){
      	$('.zip_msg').hide().html('');
      }, 6000);
    }
    
    // check proudct
    var id = $('.check_pincode').data('id');
    if(typeof id !== 'undefined'){
      id = parseInt(id);
      if($.inArray(id, product_id) === -1){
         $('.check_pincode').show();
         $('form #AddToCart').addClass('disable_btn');         
      }
    }
    
    // cart page
    
    if($('body').hasClass('template-cart')){
      $.each(cart_item, function(index, item){
           if($.inArray(item, product_id) === -1){
             $('.check_pincode').show();
             $('form [name="checkout"]').addClass('disable_btn');         
          }
      });
    }
    
    
    
  
  },
  faq_function: function(){
    
    $('.dlfq_heading').on('click', function(){
      
      $(this).toggleClass('active');
      $(this).next('.dlfq_detail').slideToggle('active');
    });
    
    var quick_view_slider = $('.product_img_slider'); 
    quick_view_slider.slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: false
   });
  
    $('.quick_view').on('click', function(){
      $(this).closest('.grid__item--collection-template').next('.featuredItem').show();
         
        //$(this).closest('.grid__item--collection-template').next('.featuredItem').find('.product_img_slider');
        var id = $(this).data('id');
        quick_view_slider.slick('slickGoTo', 1); 
    });
   
 
    
    $('.close_quick').on('click', function(){
      $(this).closest('.featuredItem').hide(); 
      
    });
    
    $('.filter_custom').on('change', function(){
      var value = $(this).val();
      window.location.href = value;
    });
    
    
  },
  fb_follow: function(that, img){     
    if(img !==null){
      $(that).addClass('active');
      $(that).find('.add_image_scroll').html('<img src="'+img+'"/>');
    }    
  },
  blog_img: function(that, img, item){
     if(img !==null){
       $(that).find('.add_image_scroll[data-id="'+item+'"]').html('<img src="'+img+'"/>');
     }
  },
  product_img: function(pd_img){
    
    $(pd_img).each(function(index, item){
      if(item['img'] !== null){
        $('.pdslider_img[data-id="'+item['id']+'"]').html('<img src="'+item['img']+'"/>')
      }
    });
    
    
    $('.js-zoom-enabled, .zoom_name').on('click', function(){
      	var img = $(this).data('zoom');
       console.log(img);
      if(typeof img != undefined){
        $('.zoom_popup .zmpp_box').html('<img src="'+img+'"/>');
        $('.zoom_popup').show();
      }
      
    });
    
    $('.zoom_popup').on('click', function(){
      $(this).hide();
    });
    
    
  },
  zoom_option: function(){
    setTimeout(function(){
      
      console.log('aaa');
       $('.js-zoom-enabled').zoom();
        $('.thumb').on('click', 'a', function(e) {
          e.preventDefault();
          var thumb = $(e.delegateTarget);
          if (!thumb.hasClass('active')) {
            thumb.addClass('active').siblings().removeClass('active');
            $('.zoom')
              .zoom({
                url: this.href
              })
              .find('img').attr('src', this.href);
          }
        });
      
    }, 600);
    
  },
  collectioin_page: function() {
    $('.pagination_txt').on('click', function() {
      $('.grid--view-items .grid_thumb').show();
      $(this).hide();
    });
  },
  comapre: function(){
    
    setTimeout(function(){
      $('.bh-sl-loc-list li[data-markerid="0"]').addClass('list-focus');
    }, 1200);

    $('form#bh-sl-user-location').on('submit', function() {
      $('.store_msg').removeClass('active').hide();
    });
    

    $('.cmp_product_btn').on('click', function(e) {
        e.preventDefault();
        var name = ''; 
      $('.cmp_tabel tbody tr:last-child .cmp_detail_buynow').each(function() {
           name += $(this).find('.cmp_product_btn').attr('row') + '-';
           name += $(this).find('.cmp_product_btn').attr('id') + '|'; 
       });
        setCookie('cmp',name,1); 
        window.location.href = $(this).attr('href');
    });

    if(getCookie('cmp') && $('body').hasClass('template-collection')){
      
      var value = getCookie('cmp');
      var myArray = value.split("|");
      $('.cmp_popup').addClass('active');
      $('body').addClass('active');
      
      $(myArray).each(function(index, item) { 
          if(item !=''){ 
              var list = item.split("-"); 
              add_value(list[0], list[1]);
          } 
      }); 
    }
    
    
    $('.cmp_link_menu').on('click', function(){
       $(this).toggleClass('active');
       $(this).next('.cmp__pdt_box').slideToggle();
    });
    
    $('.comaprefix_btn').on('click', function(){
      $('.comapre_popup').slideToggle();
    });
    
    $('.select_cmp').on('change', function(){
       var row = $(this).data('id');
       var id = $(this).val();
       add_value(row, id);
    });
    
    $('.cmp_dpwn_value').on('click', function(){
      $('.cmp_dpwn_box_value').hide();
      $(this).next('.cmp_dpwn_box_value').slideToggle();
    });
    
    $('.cmp_dpwn_box_value .cmp_dpwn_select_value').on('click', function(){
      $(this).closest('.cmp_dpwn_box_value').slideToggle();
      
      var name = $(this).data('name');
      var id = $(this).data('id');
      var row = $(this).closest('.cmp_dpwn_box').data('id');
      
      $(this).closest('.cmp_dpwn_box').find('.cmp_dpwn_txt').html(name);
       
      add_value(row, id);
    });
    
    var count = 1;
    $('.cmpup_btn').click(function(){
      
      $(this).toggleClass('active'); 
      var id = $(this).data('id');
      var html = 'Please Select '+(3 - count)+ ' More';
      $('.comapre_popup_info').hide();
      
      add_value(count, id); 
      
      if(count == 3){
        $('.cmp_popup').addClass('active'); 
        $('.cmpup_btn').removeClass('active');
        count = 2;
        if($(window).width() < 768){
          $('.cmp_ppup_box').scrollLeft(180);
        }
        $('body').addClass('active');
      }else{
        if($(this).hasClass('active')){
        	$(this).next('.comapre_popup_info').html(html).show();
        }
      }
       
      if($(this).hasClass('active')){
        count = count +1;
      }else{
        count = count - 1;
      }
       
      
    });
    
    $('.cmp_bg, .cmp_popup_close').on('click', function(){
      $('.cmp_popup').removeClass('active');
      $('body').removeClass('active');
       eraseCookie('cmp');
    });
    
    
    
    function add_value(row, id){
       
      $(cmp).each(function(index, item){
        if(item.id == id){
          var img = item.img;
          var price = item.price;
          var url = item.url;
          var title = item.title;
          
          var detail_1 = item.d_1;
          var detail_2 = item.d_2;
          var detail_3 = item.d_3;
          var detail_4 = item.d_4;
          var detail_5 = item.d_5;
          var detail_6 = item.d_6;
          var detail_7 = item.d_7;
          
          console.log(title);
          // image
          $('.cmp_img[data-id="'+row+'"] .cmp_img_show').html('<img src="'+img+'"/>');
          
          // tite
          $('.cmp_img[data-id="'+row+'"] .cmp_heading').html(title);
          $('.cmp_dpwn_box[data-id="'+row+'"] .cmp_dpwn_txt').html(title);
          
          // price
           $('.cmp_price[data-id="'+row+'"]').html(price);
           
          // url
           $('.cmp_detail_buynow[data-id="'+row+'"] .cmp_product_btn').attr('href', url).attr({'row': row, 'id': id});
          
          // detail 1
           $('.cmp_detail_1[data-id="'+row+'"]').html(detail_1);
          
           // detail 2
           $('.cmp_detail_2[data-id="'+row+'"]').html(detail_2);
          
           // detail 3
           $('.cmp_detail_3[data-id="'+row+'"]').html(detail_3);
          
           // detail 4
           $('.cmp_detail_4[data-id="'+row+'"]').html(detail_4);
          
           // detail 5
           $('.cmp_detail_5[data-id="'+row+'"]').html(detail_5);
          
          // detail 6
           $('.cmp_detail_6[data-id="'+row+'"]').html(detail_6);
          
          // detail 7
           $('.cmp_detail_7[data-id="'+row+'"]').html(detail_7);
        }
        
      });
      
    }
    
    $('.stmg_bg, .stmg_close').on('click', function() {
        $('.store_msg').hide();
    });
  },
  mobile_slider: function(goto_no){
     var slider = $('.mobile_slider_item');
    if(goto_no == 'create'){
      $('.mobile_slider_item').slick({
      	dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          adaptiveHeight: true
      });
    }else{
      console.log(goto_no);
      //slider.slick.slickGoTo(goto_no);
    }
  },
  removeProduct_cart: function(id) {
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: {
        id: id,
        quantity: 0,
      },
      success: function (data) {  
        window.location.reload();
      } 
    });
  },
  addtocartProduct_cart: function(id, qty) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: qty,
        id: id
      },
        dataType: 'json', 
       success: function (data) {  
           window.location.reload();
       } 
     });
  },
  product_slider_vaiant: function() {

    

   
    

    $('.itme_color_url').on('click', function(){
      var url = $(this).data('href');
      $(this).closest('.productContent').find('.info_href').attr('href', url);
      $(this).closest('.product-card').find('.coll_img_url').attr('href', url);
         
    });

     var slider = $('.product_slider_variant');


  

      $('.view_img').on('click', function(){
          $(this).toggleClass('active');  
          var attr = $(this).attr('data-txt');
          var html = $(this).html();
          $(this).html(attr);
          $(this).attr('data-txt', html);
        
          
          $('[data-thumbnail-slider]').slideToggle();
      });

    
    $('body').on('click', '.pdsld_thumb .variant_itme', function(event){
        var item = $('.pdsld_thumb .variant_itme').index(this)
        $('.pdsld_thumb .variant_itme').removeClass('active');
        $(this).addClass('active');

        slider.slick('slickGoTo', item);
    });


   
      
       

      function tag_img(current_value){
         
        var html = '', thumb = '';
        slider.slick('unslick');
        slider.html('');
        
        $.each(full_meida, function(index, item) {
          
          if(current_value == item.alt || current_value == 'all'){ 
           // html += '<div class="vrnd_img"> <img src="'+item.preview_image.src+'"/> </div>';
            
            if(item.type == 'image'){
               html += '<div class="vrnd_img"> <img src="'+item.src+'"/> </div>';
            }else{
               html += '<div class="vrnd_img">'+item.src+' </div>';
            } 

            //thumb
            thumb +='<div class="variant_itme"> <div class="vrnd_img">'+
                      '<img src="'+item.thumb+'">'+
                    '</div> </div>';
          } 
        }); 
         $('.product_slider_variant').html(html);
         $('.pdsld_thumb').html(thumb);

        setTimeout(function() {
           product_slider_variant();
        }, 200); 
      }
    
  },
  prouct_feature: function(){
    $('.pdft_btn').on('click', function() {
       $('.pdft_btn').removeClass('active');
       $('.pdft_mobile_item').hide();
      
       $(this).addClass('active');     
       var id = $(this).data('id');
       $('.pdft_mobile_item[data-id="'+id+'"]').slideToggle(); 
      
    });
  }
}

$(function(){
 // bkc.check_pincode();
  bkc.faq_function();
  bkc.zoom_option();
  bkc.collectioin_page();

  bkc.comapre(); 

  bkc.product_slider_vaiant(); 
    bkc.prouct_feature();
  
  if(getCookie('ppkcookie') != 1){
    $('.cookies_banner').show();    
  }
  
  $('.cok_btn_style').on('click', function(){
    $('.cookies_banner').fadeOut();    
    
    setCookie('ppkcookie',1,1);
    $('#___ratingbadge_0').addClass('remove_style');
  });
  
});

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
} 


$.fn.isOnScreen = function(){
    var win = $(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

};






/*------------- 1 June ------------------*/


$(function() {

  var current_url = $(location).attr('pathname');  
  var last = current_url.substr(current_url.length - 1);
  
  if(last == '/'){
    current_url = current_url.substring(0,current_url.length - 1);
   // window.location.href = current_url;
  }
 
  
  // scroll
  var c_url = $(location).attr('href');  
  if(c_url.indexOf('become-a-dealer') != -1){
      $("html, body").animate({ scrollTop: 0 }, 400);
    }
 
  
  var current_url = $(location).attr('pathname');  
  var last = current_url.substr(current_url.length - 1);
  
  if(last == '/'){
    current_url = current_url.substring(0,current_url.length - 1);
   // window.location.href = current_url;
  }
 
  
  // scroll
  var c_url = $(location).attr('href');  
  if(c_url.indexOf('brand-ambassador') != -1){
      $("html, body").animate({ scrollTop: 0 }, 400);
    }
  

});



$(document).ready(function (){
    if (window.location.href.indexOf("Contact_newsletter") > -1) {
    	
      $('html, body').animate({
       // scrollTop: $("#shopify-section-newsletter").offset().top - 20
        scrollTop: $("#shopify-section-newsletter").offset().top + 50
      }, 1000);
      
     }
});